import { render, staticRenderFns } from "./OrdiniCards.vue?vue&type=template&id=667849c0"
import script from "./OrdiniCards.vue?vue&type=script&lang=ts"
export * from "./OrdiniCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('667849c0')) {
      api.createRecord('667849c0', component.options)
    } else {
      api.reload('667849c0', component.options)
    }
    module.hot.accept("./OrdiniCards.vue?vue&type=template&id=667849c0", function () {
      api.rerender('667849c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrdiniCards.vue"
export default component.exports